import * as App from './requests/AppRequests'
import * as MyLearning from './requests/MyLearningRequests'
import * as Community from './requests/CommunityRequests'
import * as Home from './requests/HomeRequests'
import * as CommentLike from './requests/CommentLikeRequests'
import * as Tencent from './requests/TencentRequests'
import * as User from './requests/UserRequests'
import * as Goods from './requests/GoodsRequests'

export default {
  App,
  MyLearning,
  Community,
  Home,
  CommentLike,
  Tencent,
  User,
  Goods
}
